module.exports = __webpack_public_path__ + "media/images/application/cdasiaonline_logo-6518ce5e9686f33fec7a3efd4cedca68.png";